<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb 
          parentRouteName="AudienceList" 
          :extra-items="[
            {
              text: audience.title,
              to: 'AudienceView',
              params: $route.params.audienceId
            },
            '受眾會員'
          ]" 
        />
      </div>
    </div>
    <b-card>
      <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
        <h4 class="col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold">受眾會員</h4>
        <div
          class="
            col-12 col-xl-6
            d-flex
            flex-column flex-xl-row
            align-items-start align-items-xl-center
          "
        >
        </div>
      </div>
      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-table
              striped
              hover
              responsive
              :items="customers"
              :fields="fields"
              :busy="isLoading"
              no-local-sorting
            >
              <template #cell(avatar_url)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >
                    <b-avatar
                      :src="data.item.avatar_url"
                      variant="secondary"
                      size="2rem"
                    ></b-avatar>
                  </router-link>
                </div>
              </template>
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="d-flex justify-content-center" style="margin-top: 80px">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              @change="getCustomers"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PermissionChecker from "@/utils/PermissionChecker"
import * as consts from "@/consts";
import audienceApi from "@/apis/audience"
import {BAvatar} from "bootstrap-vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { BAvatar, BreadCrumb },
  data() {
    return {
      consts: consts,
      isLoading: false,
      audience: {},
      customers: [],
      baseFields: [
        { key: "avatar_url", label: "" },
        {
          key: "name",
          label: "LINE 名稱",
        },
      ],
      fields: [],
      currentPage: 1,
      perPage: 15,
      totalRows: 1,
      showLoading: false,
      showLoadingUpload: false,
      keyword: null,
    };
  },
  computed: {
    ...mapState('general', {
      organization: state => state.organization,
      defaultMerchantType: state => state.defaultMerchantType,
    }),
    ...mapGetters('general', [
      'branchOptions',
    ]),
    ...mapGetters('dashboardModule', {
      getModuleConfig: 'getConfig',
      getModule: 'getModule',
    }),
  },
  mounted() {
    this.init();

    this.fields = this.baseFields
                      .concat(this.getModule("customer") ? [] : this.getDefaultCustomerFields())
                      .concat(this.normalizeProfileFields());

  },
  methods: {
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    async init() {
      if (!this.checkPermission([consts.AUDIENCE_LIST_VIEW])) {
        this.$swal
          .fire({
            type: "error",
            text: "你沒有權限訪問此頁面",
            confirmButtonColor: "#d33",
          })
          .then(() => {
            this.$router.push({ name: "OrganizationList" });
          });
      } else {
        await Promise.all([
          this.getAudience(),
          this.getCustomers(),
        ])
      }
    },
    async getAudience() {
      try {
        let {data} = await audienceApi.getAudience(this.$route.params.audienceId)
        this.audience = data.data
      } catch (error) {
        console.log(error);
      }
    },
    async getCustomers(page = 1, orderBy = '', orderDesc = true) {
      try {
        this.isLoading = true;
        const { data } = await audienceApi.getCustomers(
          this.$route.params.audienceId,
          { page, order_by: orderBy, order_direction: orderDesc ? 'desc' : 'asc', per_page: this.perPage  }
        );
        this.totalRows = data.meta.total;
        this.perPage = data.meta.per_page;
        this.customers = data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    normalizeProfileFields() {
      const customerList = this.getModuleConfig("customer", "member.customer_list");

      const profileMappings =
        customerList?.find(
          (list) => list.merchant_type.toUpperCase() == this.defaultMerchantType
        )?.member_fields ?? [];

      if (profileMappings) {
        return profileMappings.map((mapping) => {
          if (mapping.matched_key.startsWith("extra.")) {
            const key = mapping.matched_key.split("extra.")[1];
            return {
              key: `profiles.${key}`,
              label: mapping.title,
            };
          } else {
            return {
              key: mapping.matched_key,
              label: mapping.title,
            };
          }
        });
      } else {
        return [];
      }
    },
    getDefaultCustomerFields() {
      return [
        { key: "outer_code", label: "識別編號" },
        { key: "mobile_phone", label: "手機" },
        { key: "email", label: "Email" },
      ];
    },
  },
};
</script>

<style lang="scss">
.modal-backdrop {
  opacity: 0.5;
}

.advance-search {
  color: #337ab7;

  &:hover {
    color: #23527c;
    text-decoration: underline;
  }
}
</style>
